import { faFile } from '@fortawesome/pro-light-svg-icons/faFile'
import { faImage } from '@fortawesome/pro-light-svg-icons/faImage'
import { Icon } from 'src/components'
import { CommentType } from 'src/components/postComments'
import { faMicrophone } from '@fortawesome/pro-light-svg-icons/faMicrophone'
import { ScreenSizes } from 'src/styles'
import { useMediaQuery } from '@hotmart/space-lib/dist/hooks'
import { MediaActionsProps } from './mediaActions.types'

const MediaActions = ({ allowMedias, disabledActions, onClick }: MediaActionsProps) => {
  const icons = {
    [CommentType.DOCUMENT]: faFile,
    [CommentType.IMAGE]: faImage,
    [CommentType.AUDIO]: faMicrophone
  }

  const isMobile = useMediaQuery(`(max-width: ${ScreenSizes.md})`)

  return (
    <div className="_d-flex">
      {allowMedias?.map((media) => {
        if (media === CommentType.AUDIO && isMobile) {
          return null
        }

        return (
          <button
            key={media}
            className="_border-0 hot-button _text-gray-900 _d-flex _p-2 _align-items-center _justify-content-center"
            disabled={disabledActions}
            data-test={`button-media-${media}`}
            onClick={() => onClick(media)}
          >
            <Icon icon={icons[media]} className="_text-gray-700" size="1x" />
            <span className="_sr-only">{media}</span>
          </button>
        )
      })}
    </div>
  )
}

export default MediaActions
